import React from 'react'

export default function Title({mainTitle}) {
    return (
        <div className='text-center mt-4 fw-bold'>
            <h1>
                {mainTitle}
            </h1>
        </div>
    )
}
